<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">医疗服务列表</div>
				<div class="titleR">
					<div class="titleRText" @click="toYlfwPackageList">医疗服务套餐查询</div>
				</div>
			</div>
			<div class="content">
				<div class="con">
					<div class="tabLine">
						<div class="tabLineL">
							<div class="tabItem" :class="[tabIndex===0?'active':'']" @click="changeTabIndex(0)">全部</div>
							<div class="tabItem" :class="[tabIndex===1?'active':'']" @click="changeTabIndex(1)">待完成</div>
							<div class="tabItem" :class="[tabIndex===2?'active':'']" @click="changeTabIndex(2)">已完成</div>
						</div>
						<div class="tabLineR">
							<el-button type="warning" size="small" @click="toAdd" style="width:116px;">新增</el-button>
						</div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							<el-input style="width:180px;margin-right: 10px;" placeholder="请输入顾客名称或手机号" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" type="warning" size="small">搜索</el-button>
							<div class="searchLabel">宠物类别</div>
							<el-select style="width:120px" v-model="search.petType" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:''},{label:'犬类',value:'犬类'},{label:'猫类',value:'猫类'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="searchLabel">支付状态</div>
							<el-select style="width:100px" v-model="search.isPay" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'未支付',value:0},{label:'已支付',value:1}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="searchLineR"></div>
					</div>
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="单号" prop="id" min-width="90">
							</el-table-column>
							<el-table-column label="套餐名称" prop="medicalServiceName" min-width="200">
							</el-table-column>
							<el-table-column label="顾客" prop="memberName" min-width="100">
							</el-table-column>
							<el-table-column label="手机号" prop="memberMobile" min-width="100">
							</el-table-column>
							<el-table-column label="昵称" prop="petName" min-width="100">
							</el-table-column>
							<el-table-column label="品种" prop="typeName" min-width="70">
							</el-table-column>
							<el-table-column label="年龄" prop="birthDay" min-width="70">
								<template slot-scope="props">
									<span>{{$public.FAge(new Date(props.row.birthDay).getTime())[0]}}岁</span>
									<span>{{$public.FAge(new Date(props.row.birthDay).getTime())[1]}}月</span>
								</template>
							</el-table-column>
							<el-table-column label="创建时间" min-width="90">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD')}}</div>
								</template>
							</el-table-column>
							<!-- <el-table-column label="支付方式" min-width="80">
								<template slot-scope="props">
									<span v-if="props.row.payType===1">全额支付</span>
									<span v-if="props.row.payType===2">套餐卡支付</span>
								</template>
							</el-table-column> -->
							<el-table-column label="支付状态" min-width="80">
								<template slot-scope="props">
									<div >
										<span style="color:#FD4E4E" v-if="props.row.isPay==0">未支付</span>
										<span style="color:#18A44C" v-if="props.row.isPay==1">已支付</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" min-width="120">
							</el-table-column>
							<el-table-column label="操作" min-width="130">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toSee(props.row)">查看</el-button>
									<el-button  v-show="$buttonAuthority('yewu-yiliaoxin-edityiliao')&&props.row.serviceStatus!==2" type="text" @click="toEdit(props.row)" size="mini">编辑</el-button>
									<el-button v-show="($buttonAuthority('yewu-yiliaoxin-delyiliao'))&&props.row.serviceStatus!==2" type="text" @click="del(props.row)" size="mini">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tabIndex:0,
				search:{
					"serviceTypeId": 0,  // 0全部 1疫苗；2驱虫;
					"payType": 0,   // 0全部 1全额支付 3套餐卡
					isPay:-1,       // 是否支付
					serviceStatus:-1,  // -1全部；1待完成；2已完成
					petType:'',       // 犬类 猫类
					keyword:'',
					begin_time:'',
					end_time:'',
				},
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			ylfwParams(){
				return this.$store.state.yiliaoxin.ylfwParams;
			},
		},
		beforeRouteEnter(to,from,next){
			next(vm=>{
				if(vm.page.page===1){
					vm.getTableData();
				}
			})
		},
		created(){
			this.page.page = this.ylfwParams.curPage||1
		},
		mounted(){
			this.tabIndex = this.ylfwParams.initialDataOflist.tabIndex||this.tabIndex;
			this.search = this.ylfwParams.initialDataOflist.search||this.search;
			this.page = this.ylfwParams.initialDataOflist.page||this.page;
			this.getTableData();
		},
		methods: {
			// 跳转
			toYlfwPackageList(){
				this.ylfwParams.type = 'packageList'
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
			},
			toAdd(){
				this.ylfwParams.type = 'add'
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
			},
			toEdit(row){
				this.ylfwParams.curRow = row
				this.ylfwParams.type = 'edit'
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
				this.$store.commit("yiliaoxin/add_router",{name:'医疗服务',data:this.ylfwParams})
			},
			toSee(row){
				this.ylfwParams.curRow = row
				this.ylfwParams.type = 'see'
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
				this.$store.commit("yiliaoxin/add_router",{name:'医疗服务',data:this.ylfwParams})
			},
			reset(){
				this.search.serviceTypeId = 0 // 0全部 1疫苗；2驱虫;
				this.search.payType = 0       // 0全部 1全额支付 3套餐卡
				this.search.isPay = -1        // 是否支付
				this.search.petType = ''       // 犬类 猫类
				this.search.keyword = ''      
				this.page.page=1;
				this.getTableData()
			},
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.ylfwParams.curPage = num
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
				this.page.page = num;
				this.getTableData();
			},
			// 删除
			del(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/MedicalService/Delete', {serviceId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 切换列表
			changeTabIndex(index){
				this.tabIndex=index;
				if(index==0){
					this.search.serviceStatus = -1;
				}else if(index==1){
					this.search.serviceStatus = 1;
				}else if(index==2){
					this.search.serviceStatus = 2;
				}
				this.page.page=1;
				this.getTableData()
			},
			getTableData(){
				let params = {
					"payType": 0, // 1全额；2消费卡
					"isPay": this.search.isPay,  // -1全部；0未支付；1已支付
					serviceStatus:this.search.serviceStatus,    // -1全部；1待完成；2已完成
					"petType": this.search.petType,    // 猫类；犬类
					"petId": "",
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": this.search.keyword
				}
				let loading=this.$loading();
				this.$http.post('/api/MedicalService/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.ylfwParams.initialDataOflist = {
					tabIndex:this.tabIndex,
					search:this.search,
					page:this.page,
				}
				this.$store.commit("yiliaoxin/set_ylfwParams",JSON.parse(JSON.stringify(this.ylfwParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'医疗服务',data:JSON.parse(JSON.stringify(this.ylfwParams))})
			},
		},
		// beforeDestroy(){
		// 	this.ylfwParams.initialDataOflist = {
		// 		tabIndex:this.tabIndex,
		// 		search:this.search,
		// 		page:this.page,
		// 	}
		// 	this.$store.commit("yiliaoxin/set_ylfwParams",JSON.parse(JSON.stringify(this.ylfwParams)))
		// },
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;height: 100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
